import { render, staticRenderFns } from "./customerCount.vue?vue&type=template&id=af586182&scoped=true&"
import script from "./customerCount.vue?vue&type=script&lang=js&"
export * from "./customerCount.vue?vue&type=script&lang=js&"
import style0 from "./customerCount.vue?vue&type=style&index=0&id=af586182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af586182",
  null
  
)

component.options.__file = "customerCount.vue"
export default component.exports